import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f6e50ff6558f0014eaa377_1782649698335_fc8306ea/ibrainacademy/src/app/not-found.tsx");
